import { IResourceComponentsProps, useExport, useNavigation } from '@pankod/refine-core'
import { CSVLink } from 'react-csv'
import React, { useEffect, useState } from 'react'
import { getSubThemeData } from 'gql/query'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  useImport,
  ImportButton,
  Input,
  Divider,
  Form,
  Button,
  useTable,
} from '@pankod/refine-antd'
// import { useTable } from '@pankod/refine-core'

import { ISubTheme } from 'interfaces'
import { CreateSubTheme } from './create'
import { EditSubTheme } from './edit'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import Permissions from 'permissions'
import { createUserHistory } from 'gql/mutations'
import { subThemeImportFormat } from 'helpers/import_template_format/importTemplate'

type Permission = {
  granted?: boolean
}

const { PlusOutlined, ExportOutlined } = Icons

export const SubThemesList: React.FC<IResourceComponentsProps> = () => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const { push } = useNavigation()
  const [pagination, setHasPagination] = useState<any>(true)
  const [readPermission, setReadPermission] = useState<Permission>({})
  const hiddenRole = ['srmanager', 'subjectincharge', 'qcreator', 'qreviewer', 'qapprover']
  const { tableProps, searchFormProps, sorter, tableQueryResult, setFilters } = useTable<ISubTheme>({
    hasPagination: pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: {
      fields: [
        'id',
        'name',
        'theme_id',
        { theme: ['name', { subject: ['name'] }] },
        'created_at',
        { topics: ['id'] },
        { paper_template_sub_sections: ['id'] },
        { work_requests: ['id'] },
        { questions: ['id'] },
      ],
    },
    onSearch: (values: any) => {
      return [
        {
          field: 'name',
          operator: 'contains',
          value: `%${values.title}%`,
        },
      ]
    },
  })
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('sub_themes'))
    }
  }, [userRole])
  useEffect(() => {
    if (!readPermission?.granted && readPermission?.granted !== undefined) push('/')
  }, [readPermission, userRole])
  const { formProps, modalProps, show } = useModalForm({
    resource: 'sub_themes',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'sub_themes',
    action: 'edit',
    metaData: {
      fields: ['id', 'name', 'theme_id', { theme: ['name', { subject: ['name'] }] }, 'created_at'],
    },
  })
  const [tableData, setTableData] = useState([])

  const importProps = useImport<ISubTheme>({
    mapData: item => {
      // if (item.name !== '')
      return {
        name: item.name,
        theme_id: item.theme_id,
        created_by: user?.id,
      }
    },
    onFinish(results) {
      if (results?.succeeded) createUserHistory('sub_themes', 'import', '', user?.id, userRole)
    },
  })

  const hideDeleteButton = (record: ISubTheme): boolean => {
    let ptss = record?.paper_template_sub_sections
    let wr = record?.work_requests
    let q = record?.questions
    let t = record?.topics
    if (ptss !== undefined && wr !== undefined && q !== undefined && t !== undefined) {
      const shouldHide = ptss.length > 0 || wr.length > 0 || q.length > 0 || t.length > 0
      return shouldHide
    }
    return false
  }

  useEffect(() => {
    getSubThemeData().then((resp: any) => {
      let exportData: any = []
      resp.sub_themes.forEach(async (element: any) => {
        let mockObj = {
          id: element.id,
          name: element.name,
          report_theme_id: element?.theme?.report_theme_id,
          report_theme: element?.theme?.report_theme?.name,
          theme_id: element.theme_id,
          theme_name: element.theme.name,
          created_at: element.created_at,
        }
        exportData.push(mockObj)
      })
      setTableData(exportData)
    })
  }, [tableQueryResult?.data?.data])
  const csvData = [subThemeImportFormat.map(item => item.toString())]
  return (
    <List
      pageHeaderProps={{
        extra: [
          !hiddenRole?.includes(userRole) ? <ImportButton {...importProps} /> : null,
          <CSVLink
            data={tableData}
            asyncOnClick={true}
            filename={`Sub_Themes_ ${Math.round(new Date().getTime() / 1000)}`}
            className="ant-btn ant-btn-default"
            hidden={hiddenRole?.includes(userRole)}
            onClick={() => createUserHistory('sub_themes', 'export', '', user?.id, userRole)}
          >
            <ExportOutlined /> Export
          </CSVLink>,

          // <Button key="export paper" type="default" style={{ marginLeft: '5px' }}>
          //   <CSVLink key="export" data={csvData} filename={`sub_theme_ImportFormat${Math.round(new Date().getTime() / 1000)}`}>
          //     <ExportOutlined /> Download Import Format
          //   </CSVLink>
          // </Button>,

          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => show()}
            hidden={['qcreator', 'qreviewer', 'qapprover'].includes(userRole)}
          />,
        ],
      }}
    >
      <Form {...searchFormProps}>
        <Space>
          <Form.Item name="title">
            <Input
              placeholder="Search by title"
              allowClear
              onChange={e => {
                if (e.type === 'click') {
                  searchFormProps.form?.submit()
                }
              }}
            />
          </Form.Item>
          <Button icon={<Icons.SearchOutlined />} onClick={searchFormProps.form?.submit}>
            Search
          </Button>
        </Space>
        {!(userRole === 'qcreator' || userRole === 'qreviewer' || userRole === 'qapprover') && (
          <Button key="export paper" type="default" style={{ marginLeft: '5px' }}>
            <CSVLink key="export" data={csvData} filename={`sub_theme_ImportFormat${Math.round(new Date().getTime() / 1000)}`}>
              <ExportOutlined /> Download Import Format
            </CSVLink>
          </Button>
        )}
      </Form>
      <Divider />
      <Table {...tableProps}>
        <Table.Column dataIndex="name" title="Name" />

        <Table.Column<ISubTheme> dataIndex="theme_id" render={(_, record) => record.theme.name} title="Theme" />
        <Table.Column<ISubTheme> dataIndex="subject_id" render={(_, record) => record.theme?.subject?.name} title="Subject" />

        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<ISubTheme>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
                hidden={
                  (record?.questions && record?.questions?.length > 0) ||
                  (record?.paper_template_sub_sections && record?.paper_template_sub_sections.length > 0) ||
                  userRole === 'qcreator' ||
                  userRole === 'qapprover' ||
                  userRole === 'qreviewer'
                }
                onClick={() => {
                  editShow(record.id)
                }}
              />
              <DeleteButton
                size="small"
                type="link"
                icon={null}
                recordItemId={record.id}
                hidden={hideDeleteButton(record) || userRole === 'qcreator' || userRole === 'qapprover' || userRole === 'qreviewer'}
              />
            </Space>
          )}
        />
      </Table>
      <CreateSubTheme modalProps={modalProps} formProps={formProps} />
      <EditSubTheme modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
